// extracted by mini-css-extract-plugin
module.exports = {"placemark":"a10a3f92e9--placemark--VWWJ8","append":"a10a3f92e9--append--ua5fX"};